const videoTemplatesLocalized = i18n => ({
  '752ca3e5-d09a-4ca7-bdbc-f9c14b2148aa': {
    LocalizedTemplateName: i18n.getString(_TL_('Microsoft Ad Animated Fun Template')),
    LocalizedTemplateDescription: i18n.getString(_TL_('A fun animated template for advertisers to promote their products.')),
  },
  '00000002-0000-0000-0000-000000000001': {
    LocalizedTemplateName: i18n.getString(_TL_('Animated fun')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Grab your audience\'s attention with eye-catching colors and a bold style designed to make your video stand out.')),
  },
  '00000002-0000-0000-0000-000000000002': {
    LocalizedTemplateName: i18n.getString(_TL_('Bold and colorful')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Grab your audience\'s attention with eye-catching colors and a bold style designed to make your video stand out.')),
  },
  '00000002-0000-0000-0000-000000000003': {
    LocalizedTemplateName: i18n.getString(_TL_('Corporate and professional')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Showcase a video that has a professional look, designed to reach customers interested in your business.')),
  },
  '00000002-0000-0000-0000-000000000004': {
    LocalizedTemplateName: i18n.getString(_TL_('Modern minimalist')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Elevate your brand with a sleek and modern-looking video designed to catch the eye of your target audience.')),
  },
  '00000002-0000-0000-0000-000000000005': {
    LocalizedTemplateName: i18n.getString(_TL_('Whimsical, fantasy')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Attract your audience with a creative, whimsical video designed to spark interest in your product or service.')),
  },
  '00000002-0000-0000-0000-000000000007': {
    LocalizedTemplateName: i18n.getString(_TL_('Elegance and luxury')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Appeal to customers with a video that’s inspired by elegance, luxury, and beauty, designed to spark interest in your product or service.')),
  },
  '00000002-0000-0000-0000-000000000008': {
    LocalizedTemplateName: i18n.getString(_TL_('Nature-inspired')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Showcase a nature-inspired video that\'s designed to appeal to customers who love the great outdoors.')),
  },
  '00000002-0000-0000-0000-000000000009': {
    LocalizedTemplateName: i18n.getString(_TL_('Tech-savvy')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Grab the attention of customers with a tech-savvy, innovative video.')),
  },
  '00000002-0000-0000-0000-000000000010': {
    LocalizedTemplateName: i18n.getString(_TL_('Urban cool')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Attract your target audience with a modern, urban, and trendy video.')),
  },
  '00000002-0000-0000-0000-000000000011': {
    LocalizedTemplateName: i18n.getString(_TL_('Vintage, retro')),
    LocalizedTemplateDescription: i18n.getString(_TL_('Bring back the classics with a retro-inspired video designed to evoke nostalgic fun.')),
  },
});

export default videoTemplatesLocalized;
